export default "__VITE_ASSET__Ckg99eu0__"